import { TabPanel } from "@mui/lab";
import { styled } from "@mui/material";

const StyledTabPanel = styled(TabPanel)({
  overflowY: "auto",
  height: "100%",
  flex: "1",
  padding: "0",
});

export default StyledTabPanel;
